import React from "react";
import { Box } from "@mui/material";

function SMStable({ smsData }) {
  //@Param date: format `YYYY-MM-DD HH:MM:SS`
  const formatDate = (date) => {
    const [day, time] = date.split(" ");
    return { day: day.slice(2, 10), time };
  };

  // Ensure smsData.record is always an array
  const records = Array.isArray(smsData.record) ? smsData.record : smsData.record ? [smsData.record] : [];

  return (
    <Box
      sx={{
        overflowY: "scroll",
      }}
    >
      <table className="full-width-table">
        <thead>
          <tr className="header-row">
            <th className="table-date-header">Date/Time</th>
            <th className="table-date-header">Phone no.</th>
            <th>Message</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {records.length ? (
            records.map((item, index) => (
              <tr key={index}>
                <td>
                  <div style={{ display: "block" }}>
                    <p>{formatDate(item.smslog.dt).day}</p>
                    <p>{formatDate(item.smslog.dt).time}</p>
                  </div>
                </td>
                <td>{item?.smslog?.phoneno}</td>
                <td>{item.smslog.phonetxt}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" style={{ textAlign: "center", padding: "1em" }}>
                No SMS found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </Box>
  );
}

export default SMStable;
